import React from 'react';
import {BreadcrumbVisual} from "./breadcrumb-visual/BreadcrumbVisual";

export function BreadcrumbReact({elements, ...rest}) {

  return <BreadcrumbVisual breadCrumbElements={elements} {...rest} />
}
